module.exports = __webpack_public_path__ + "media/images/dogs/emergency-vets-usa-local-veterinarian-pet-hospitals.jpg";